import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Dispatch } from 'redux';
import { CSVLink } from 'react-csv';

import { getWorkspaces } from '../../../repositories/WorkspaceRepository';
import { getWorkspaceName } from '../../../stores/workspaces/selectors';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import {
  getSorting,
  getFilters,
  getSearch,
} from '../../../stores/tables/selectors';
import { Data } from 'react-csv/components/CommonPropTypes';
import { TableFilters, TableSorting } from '../../../stores/tables/state';

interface Props extends LocalizeContextProps {
  hasPrivilege: (privileges: string[]) => boolean;
  sorting: TableSorting;
  filters: TableFilters;
  search: string;
  getWorkspaceName: (id: string) => string;
}
interface State {
  csvData: Data;
}

const initialState: State = {
  csvData: [],
};

class ExportReportAction extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = initialState;
  }

  public render() {
    const t = this.props.translate;
    if (this.props.hasPrivilege(['WORKSPACE_ADMIN', 'SUPER_ADMIN'])) {
      return (
        <React.Fragment>
          <CSVLink
            data={this.state.csvData}
            filename='workspaces.csv'
            className='hidden'
            target='_blank'
            ref={(r: any) => (this.csvLink = r)}
            separator=';'
          />
          <Button onClick={this.writeCSVReport} className='mr-2'>
            <FontAwesomeIcon icon={['fal', 'th-list']} className='mr-4' />
            {t('workspaces.button.workspaceReport')}
          </Button>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }

  private writeCSVReport = () => {
    getWorkspaces(
      999999,
      0,
      {
        column: this.props.sorting?.column ?? 'name',
        order: this.props.sorting?.order ?? 'asc',
      },
      {
        u: this.props.filters?.u,
        a: this.props.filters?.a,
        g: this.props.filters?.g,
      },
      this.props.search
    ).then(workspaces => {
      let csvList = [['Name', 'Parent']];
      workspaces.items.forEach(workspace => {
        csvList.push([workspace.name, this.getParentName(workspace.parent?.id)]);
      });
      this.setState({ csvData: csvList }, () => {
        this.csvLink.link.click();
      });
    });
  };
  private csvLink: any;

  private getParentName = (workspaceId?: string) => {
    if (workspaceId === undefined) {
        return '';
    } else {
        return this.props.getWorkspaceName(workspaceId);
    }

}
}

const mapStateToProps = (state: RootState) => {
  return {
    hasPrivilege: hasPrivilege(state),
    getWorkspaceName: getWorkspaceName(state),
    sorting: getSorting(state, 'workspaces'),
    filters: getFilters(state, 'workspaces'),
    search: getSearch(state, 'workspaces'),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize(ExportReportAction));
